// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-dYz","clinicsSelect":"styles_clinicsSelect__N6apg"};